import React from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Tabs,
  Tab
} from 'material-ui';
import {dbase} from "../../../../firebase";
import {FiberNew, Warning} from "material-ui-icons";
import UnreadNotifications from './notifications/UnreadNotifications';
import EventNotifications from './notifications/EventNotifications';
import notificationsCardStyle from "./variables/styles/notificationsCardStyle";
import {getUnitID} from "../../utils";
import {PRIORITY_HIGH, PRIORITY_LOW, PRIORITY_MEDIUM} from "../../../recording/utils";
import {byPropKey} from "../../../utils";

const NOTIFICATION_PREVIEW_LOAD_LIMIT = 50;

/**
 * A notifications section to display the
 * unread and event notifications to the user
 */
class NotificationsCard extends React.Component {
    state = {
        value: 0,
        unread: [],
        events: []
    };

    /**
     * @returns {boolean} {@code true} if the
     * recording has not been read yet.
     * The behaviour defaults to unread if the
     * key {@code isUnread} is not present in
     * {@code recordingData}.
     */
    isUnread = (recording) => {
        return (!('isUnread' in recording) || recording.isUnread);
    };

    /**
     * @returns {boolean} {@code true} if the
     * recording has a priority status that
     * is not null (i.e. user recording).
     */
    isEvent = (recording) => {
        return recording.priority
            && (recording.priority.trim() === PRIORITY_HIGH ||
                recording.priority.trim() === PRIORITY_MEDIUM ||
                recording.priority.trim() === PRIORITY_LOW);
    };

    componentDidMount() {
        if (this.props.selectedUnit) {
            // 1. Attempt to obtain all recordings of a unitID once into a low memory json
            dbase.getRecordingsOnceUpToLimit(getUnitID(this.props.selectedUnit), NOTIFICATION_PREVIEW_LOAD_LIMIT)
                .then(snapshot => {
                    const recordingsSnapshot = snapshot.val();
                    // 2. Sort the obtained values by key and reverse them (latest first by default)
                    const arrayOfKeys = Object.keys(recordingsSnapshot).sort().reverse();
                    let unread = [];
                    // 3. Map the obtained json into our unread schema to be displayed to the endUser.
                    // Break when unread has reached length of 5.
                    for (let i = 0; i < arrayOfKeys.length; i++) {
                        const recording = recordingsSnapshot[arrayOfKeys[i]];
                        if (this.isUnread(recording)) {
                            unread.push({...recordingsSnapshot[arrayOfKeys[i]], recordingID: arrayOfKeys[i]});
                        }
                        if (unread.length >= 5) { break; }
                    }
                    this.setState(byPropKey('unread', unread));
                    let events = [];
                    // 4. Map the obtained json into our event schema to be displayed to the endUser.
                    // Break when event has reached length of 5.
                    for (let i = 0; i < arrayOfKeys.length; i++) {
                        const recording = recordingsSnapshot[arrayOfKeys[i]];
                        if (this.isEvent(recording)) {
                            events.push({...recordingsSnapshot[arrayOfKeys[i]], recordingID: arrayOfKeys[i]});
                        }
                        if (events.length >= 5) { break; }
                    }
                    this.setState(byPropKey('events', events));
                })
                .catch(() => {});
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    render() {
        const { classes, headerColor } = this.props;
        return (
            <Card className={classes.card}>
                <CardHeader
                    classes={{
                        root: classes.cardHeader +
                        " " +
                        classes[headerColor + "CardHeader"],
                        title: classes.cardTitle,
                        content: classes.cardHeaderContent
                    }}
                    title="Notifications:"
                    action={
                        <Tabs
                            classes={{
                                flexContainer: classes.tabsContainer
                            }}
                            value={this.state.value}
                            onChange={this.handleChange}
                            textColor="inherit"
                        >
                            <Tab
                                classes={{
                                    wrapper: classes.tabWrapper,
                                    labelIcon: classes.labelIcon,
                                    label: classes.label
                                }}
                                icon={<FiberNew className={classes.tabIcon} />}
                                label={"Unread"}
                            />
                            <Tab
                                classes={{
                                    wrapper: classes.tabWrapper,
                                    labelIcon: classes.labelIcon,
                                    label: classes.label
                                }}
                                icon={<Warning className={classes.tabIcon} />}
                                label={"Events"}
                            />
                        </Tabs>
                    }
                />
                <CardContent>
                    {this.state.value === 0 && (
                        <Typography component="div">
                            <UnreadNotifications
                                notifications={this.state.unread}
                            />
                        </Typography>
                    )}
                    {this.state.value === 1 && (
                        <Typography component="div">
                            <EventNotifications
                                notifications={this.state.events}
                            />
                        </Typography>
                    )}
                </CardContent>
            </Card>
        );
    }
}

NotificationsCard.propTypes = {
    classes: PropTypes.object.isRequired,
    headerColor: PropTypes.oneOf(["orange", "green", "red", "blue", "darkblue", "navy", "purple"])
};

export default withStyles(notificationsCardStyle)(NotificationsCard);



// WEBPACK FOOTER //
// ./src/components/unit/summary/cards/NotificationsCard.jsx